@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';
@import '~less/layout/typography';

/*
 * Panels
 *
 * Extend Bootstrap Panels
 */

// Base class
.panel {
  margin-bottom: 20px;
  background-color: @panel-bg;
  border: 1px solid @panel-border;
  border-radius: @panel-border-radius;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  // https://developer.mozilla.org/en-US/docs/Web/CSS/word-wrap
  word-wrap: break-word;
  h3 {
    font-size: @font-size-large;
    line-height: @line-height-large;
  }

  // Optional heading
  .panel-heading {
    display: block;
    background-color: @panel-heading-bg;
    margin: 0 0 10px 0;
    margin-left: 15px;
    margin-right: 15px;
    background: transparent;
    border: 0;
    border-bottom: 1px solid @panel-border;
    border-radius: 0;
    padding: 10px 0;
    font-size: 22px;
    line-height: 24px;
    .font-brand-regular();
    @media (max-width: @screen-xs-max) {
      font-size: 19px;
    }
  }

  // Use this to wrap long texts into shorter box with "show more" link at the bottom
  .panel-more-wrap {
    position: relative;
    > button {
      border: 0;
      background-color: transparent;
      color: inherit;
      font: inherit;
    }
    .panel-more-fade {
      position: absolute;
      bottom: 0;
      display: block;
      width: 100%;
      text-align: center;
      cursor: pointer;
      padding: 120px 0 5px 0;
      font-weight: bold;

      // Vertical gradient, from top to bottom
      background: linear-gradient(
        to bottom,
        fade(@panel-bg, 0%) 0%,
        fade(@panel-bg, 96%) 80%
      );
      &:hover {
        transition: color 0.4s;
        color: lighten(@text-color, 40%);
      }
    }
  }
}

.panel-disabled {
  background-color: rgba(255, 255, 255, 0.4);
  .panel-body,
  .panel-footer,
  .panel-heading {
    opacity: 0.4;
  }
  // Ares inside disabled panels which are normally visible
  // Apply this only to .panel-{body|footer|heading}
  .panel-disabled-highlighted {
    opacity: 1;
  }
}

.panel-loading {
  &,
  * {
    color: lighten(@gray-lighter, 2%) !important;
  }
}

// Slightly transcluent white panel
.panel-glass {
  background: rgba(255, 255, 255, 0.9);
  border-color: transparent;
}

/**
 * Extending Bootstrap panels
 */
.panel.is-highlighted {
  border-color: lighten(@brand-primary, 20%);
  box-shadow: 0 0 5px lighten(@brand-primary, 35%);
}

.panel.panel-transparent {
  box-shadow: none;
  &,
  .panel-heading,
  .panel-body,
  .panel-footer {
    background-color: transparent;
    border-color: transparent;
  }
}
